import { EventCard } from "../Events/shared/EventCard.js";
import { LocationCard } from "../Locations/shared/LocationCard.js";
import { LocationLogEntryCard } from "../Locations/shared/LocationLogEntries/LocationLogEntryCard.js";
import { RecordCard } from "../Records/shared/RecordCard.js";
import { ReportCard } from "../Reports/shared/ReportCard.js";
import { UserCard } from "../Users/shared/UserCard.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/shared/RefLinkRefCard.tsx
var TYPE_COMPONENTS = {
	event: (id) => /* @__PURE__ */ jsx(EventCard, { eventId: id }, id),
	location: (id) => /* @__PURE__ */ jsx(LocationCard, { locationId: id }, id),
	["location-log-entry"]: (id) => /* @__PURE__ */ jsx(LocationLogEntryCard, { entryId: id }, id),
	record: (id) => /* @__PURE__ */ jsx(RecordCard, { recordId: id }, id),
	report: (id) => /* @__PURE__ */ jsx(ReportCard, { reportId: id }, id),
	user: (id) => /* @__PURE__ */ jsx(UserCard, { userId: id }, id)
};
/**
* A component that renders a card for a ref link.
*/
var RefLinkRefCard = ({ type, value }) => {
	if (!TYPE_COMPONENTS[type]) return null;
	return TYPE_COMPONENTS[type](value);
};
//#endregion
export { RefLinkRefCard };

//# sourceMappingURL=RefLinkRefCard.js.map